import React from "react";
import { connect } from "react-redux";

import { getData } from "Source/globalFunction";

import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        files: store.files
    };
})

class Collaborator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchIsLoading: false,
            searched: []
        }
    }

    render() {
        const { dispatch, projectId, files } = this.props;

        // TODO: For spring cleaning. 
        const searchUser = value => {
            const url = `/api/projects/${projectId}/members`;
            let params = {};
            if (value) {
                params.memberName = value;
            }
            this.setState({ ...this.state, searchIsLoading: true });
            getData(url, { params }, response => {
                if (response) {
                    this.setState({
                        ...this.state,
                        searchIsLoading: false,
                        searched: response.data.map(m => {
                            const user = m.user || {};
                            return {
                                value: user.id,
                                label: `${user.firstName} ${user.lastName}`,
                                others: {
                                    id: user.id,
                                    firstname: user.firstName,
                                    lastName: user.lastName,
                                    role: m.role || '',
                                    avatar: user.avatar
                                }
                            };
                        })
                    })
                }
            })
        }

        const handleOpenSelect = () => {
            searchUser();
        }

        const handleSearch = (value) => {
            searchUser(value);
        }

        const handleSelect = (value) => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {uploadedBy: value} });
        }

        const handleClear = () => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {uploadedBy: {}} });
        }
        
        return (
            <div class="optionRow">
                <span>Collaborator</span>
                <div class="optionChoices searchIcon">
                    <Select 
                        showSelectedInOptions={false}
                        isSearchable={true}
                        isLoading={this.state.searchIsLoading}
                        classes={{options: "filesFilterOptions"}}
                        placeholder="Search"
                        options={this.state.searched}
                        selected={files.filters.options.uploadedBy}
                        renderOption={option => (
                            <div class="memberOption">
                                <div class="memberMainDetails">
                                    <Avatar name={option.label} disableTooltip={true} image={option.others.avatar !== "default.png" ? `${this.props.avatarBaseUrl}${option.others.avatar}` : null} />
                                    <span>{option.label}</span>
                                </div>
                            </div>
                        )} 
                        onOpen={handleOpenSelect}
                        onSearch={handleSearch}
                        onChange={handleSelect}
                        onClearSelected={handleClear}
                        isClose={files.filters.isCleared}
                    />
                </div>
            </div>
        );
    }
}

export default Collaborator;